module.exports = __webpack_public_path__ + "img/circle-arrow-right.9b3a3a8f.svg";